module.exports = __webpack_public_path__ + "media/paris-screen-video.cf8ea477.mp4";